<template>
  <aside class="sidebar">
    <div class="logo">
      <router-link to="/Home">
        <span class="material-icons align-middle">view_list</span>
        <span class="toggle-checked-hide-aside-text">Record</span>
      </router-link>
    </div>
    <div class="profile">
      <div class="profile-info">
        <span class="material-icons align-middle">face</span>
        <span class="toggle-checked-hide-aside-text">Profile</span>
      </div>
    </div>
    <div class="nav-left">
      <div>
        <a href="">
          <router-link to="/Home">
            <span class="material-icons align-middle">shopping_bag</span>
            <span class="toggle-checked-hide-aside-text">購買明細</span>
          </router-link>
        </a>
      </div>
      <div>
        <a href="">
          <router-link to="/ForSale">
            <span class="material-icons align-middle">store</span>
            <span class="toggle-checked-hide-aside-text">待售明細</span>
          </router-link>
        </a>
      </div>
      <div>
        <a href="">
          <router-link to="/Sold">
            <span class="material-icons align-middle">paid</span>
            <span class="toggle-checked-hide-aside-text">出售明細</span>
          </router-link>
        </a>
      </div>
      <div>
        <a href="">
          <router-link to="/Sum">
            <span class="material-icons align-middle">savings</span>
            <span class="toggle-checked-hide-aside-text">金額明細</span>
          </router-link>
        </a>
      </div>
      <div>
        <a href="">
          <router-link to="">
            <span class="material-icons align-middle">login</span>
            <span class="toggle-checked-hide-aside-text">沒有功能的登入</span>
          </router-link>
        </a>
      </div>
    </div>
  </aside>
</template>
